<template>
  <div>
    <Common v-bind="$attrs" :code="typeChoosed" ref="common" v-model="commonForm" />
    <Server v-bind="$attrs" v-if="typeChoosed.type === 1" ref="server" v-model="serverForm" />
    <MicroStation
      v-bind="$attrs"
      v-if="typeChoosed.type === 2"
      ref="microStation"
      v-model="stationForm"
    />
    <Camera v-bind="$attrs" ref="camera" v-if="typeChoosed.type === 3" v-model="cameraForm" />
    <MNInstrument
      v-bind="$attrs"
      v-if="typeChoosed.type === 4"
      ref="mnInstrument"
      v-model="mnForm"
    />
    <NVR v-bind="$attrs" ref="nvr" v-if="typeChoosed.type === 5" v-model="nvrForm" />
    <Loadometer
      v-bind="$attrs"
      v-if="typeChoosed.type === 6"
      ref="loadometer"
      v-model="loadoForm"
    />
    <ChargingPile
      v-bind="$attrs"
      v-if="typeChoosed.type === 7"
      ref="chargingPile"
      v-model="pileForm"
    />
    <WaterMeter
      v-bind="$attrs"
      v-if="typeChoosed.type === 8"
      ref="waterMeter"
      v-model="waterForm"
    />
    <EntranceGuard
      v-bind="$attrs"
      v-if="typeChoosed.type === 9"
      ref="entranceGuard"
      v-model="guardForm"
    />
    <Crawler v-bind="$attrs" v-if="typeChoosed.type === 10" ref="crawler" v-model="crawlerForm" />
    <Footer v-bind="$attrs" ref="footer" v-model="footForm" />
  </div>
</template>
<script>
import { isEmpty } from 'lodash';
import Footer from './Footer';
import Common from './Common';
import Camera from './Camera';
import NVR from './NVR';
import MNInstrument from './MNInstrument';
import MicroStation from './MicroStation';
import ChargingPile from './ChargingPile';
import Loadometer from './Loadometer';
import WaterMeter from './WaterMeter';
import EntranceGuard from './EntranceGuard';
import Crawler from './Crawler';
import Server from './Server';
export default {
  components: {
    Common,
    Footer,
    Camera,
    NVR,
    MNInstrument,
    MicroStation,
    ChargingPile,
    Loadometer,
    WaterMeter,
    EntranceGuard,
    Crawler,
    Server
  },
  props: {
    deviceTypeCode: {
      default: ''
    },
    typeId: {
      default: ''
    },
    deviceType: {
      require: true
    }
  },
  data() {
    return {
      typeChoooseList: {
        server: {
          type: 1,
          form: 'serverForm',
          ref: 'server'
        },
        microstation: {
          type: 2,
          form: 'stationForm',
          ref: 'microStation'
        },
        camera: {
          type: 3,
          form: 'cameraForm',
          ref: 'camera'
        },
        daati: {
          type: 4,
          form: 'mnForm',
          ref: 'mnInstrument'
        },
        nvr: {
          type: 5,
          form: 'nvrForm',
          ref: 'nvr'
        },
        weighing_device: {
          type: 6,
          form: 'loadoForm',
          ref: 'loadometer'
        },
        charging_pile: {
          type: 7,
          form: 'pileForm',
          ref: 'chargingPile'
        },
        water_meter: {
          type: 8,
          form: 'waterForm',
          ref: 'waterMeter'
        },
        gate: {
          type: 9,
          form: 'guardForm',
          ref: 'entranceGuard'
        },
        reptile: {
          type: 10,
          form: 'crawlerForm',
          ref: 'crawler'
        }
      },
      typeChoosed: {},
      commonForm: {
        versionChoosed: {},
        uniqueNumber: '',
        deviceBrand: '',
        agreement: [],
        deviceSeries: '',
        parameter: []
      },
      cameraForm: {
        deviceModel: '',
        factoryNo: '',
        status: '',
        deviceNoNational: '',
        channelNo1: '',
        serialNum: '',
        channelNum: '',
        hardDiskNum: '',
        callInNum: '',
        callOutNum: '',
        masterVersion: '',
        codeVersion: '',
        webVersion: '',
        pluginVersion: '',
        time: '',
        mac: '',
        interGeneration: '0'
      },
      footForm: {
        lng: '',
        lat: '',
        deviceIp: '',
        remark: '',
        fileIdList: []
      },
      nvrForm: {
        deviceModel: '',
        factoryNo: '',
        status: '',
        deviceNoNational: '',
        serialNum: '',
        channelNum: '',
        hardDiskNum: '',
        callInNum: '',
        callOutNum: '',
        masterVersion: '',
        codeVersion: '',
        webVersion: '',
        pluginVersion: '',
        time: '',
        mac: ''
      },
      mnForm: {
        deviceModel: '',
        factoryNo: '',
        mnNum: '',
        status: '',
        interface: '',
        standard: '',
        capacity: '',
        communication: '',
        show: '',
        battery: '',
        sys: ''
      },
      stationForm: {
        deviceModel: '',
        factoryNo: '',
        status: '',
        collector: '',
        screen: '',
        workEnv: '',
        communication: '',
        workCurrent: '',
        sleepCurrent: '',
        extension: ''
      },
      pileForm: {
        deviceModel: '',
        factoryNo: '',
        status: '',
        ratedPower: '',
        outCurrentArea: '',
        voltage: '',
        temperature: '',
        humidity: '',
        communication: '',
        technologyStandard: '',
        interfaceStandard: ''
      },
      loadoForm: {
        deviceModel: '',
        factoryNo: '',
        status: ''
      },
      waterForm: {
        deviceModel: '',
        factoryNo: '',
        status: ''
      },
      guardForm: {
        deviceModel: '',
        factoryNo: '',
        status: ''
      },
      crawlerForm: {
        deviceModel: '',
        factoryNo: '',
        status: ''
      },
      serverForm: {
        deviceModel: '',
        factoryNo: '',
        status: '',
        cpu: '',
        ram: '',
        hardDisk: '',
        bandwidth: '',
        os: [],
        lanIp: ''
      }
    };
  },
  watch: {
    deviceTypeCode: {
      immediate: true,
      handler: function (val) {
        if (!val) {
          return;
        }
        this.typeChoosed = this.typeChoooseList[val] || {};
      }
    },
    typeChoosed: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.$nextTick(() => {
          this.$refs.common.change();
          this.$refs.footer.reset();
        });
        if (isEmpty(oldVal)) {
          return;
        }
        this.$refs[oldVal.ref].reset();
      }
    }
  },
  methods: {
    validate() {
      const commonType = this.$refs.common.validate();
      const footType = this.$refs.footer.validate();
      const deviceType = this.$refs[this.typeChoosed.ref]
        ? this.$refs[this.typeChoosed.ref].validate()
        : false;
      if (!this.$refs[this.typeChoosed.ref]) {
        // this.$message.error('当')
        return;
      }
      return commonType && footType && deviceType;
    },
    setData(data) {
      console.log(data);
      this.$refs.common.setData(data);
      this.$refs.footer.setData(data);
      this.$refs[this.typeChoosed.ref].setData(data);
    },
    submit() {
      const commonData = this.$refs.common.getData();
      const footerData = this.$refs.footer.getData();
      const mainData = this.$refs[this.typeChoosed.ref].getData();
      const data = { ...commonData, ...footerData, ...mainData };
      return data;
    },
    reset() {
      this.$refs.common.reset();
      this.$refs.footer.reset();
      if (this.$refs[this.typeChoosed.ref]) {
        this.$refs[this.typeChoosed.ref].reset();
      }
    },
    clearValidate() {
      this.$refs.common.clear();
    },
    getNoAgain() {
      switch (this.deviceTypeCode) {
        case 'camera':
          this.$message.error('视频通道号重复，请重新获取');
          this.getChannelAgian();
          break;
        case 'nvr':
          this.$message.error('国标设备编号重复，请重新获取');
          this.getNationAgian();
          break;
      }
    },
    getNationAgian() {
      this.$refs[this.typeChoosed.ref].getNationAgian();
    },
    getChannelAgian() {
      this.$refs[this.typeChoosed.ref].getChannelAgian();
    }
  }
};
</script>
